/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import PropTypes from "prop-types";
import InputCheckbox from "Components/input-checkbox";

const Mobile = ({ margin, isSelected, onSelected }) => (
	<div>
		<div className="filter-menu">
			<div className="head flex">
				<span className="title">On Sale</span>
				<span className="title">
					<InputCheckbox
						title=""
						isSelected={isSelected}
						onClick={onSelected}
					/>
				</span>
			</div>
		</div>
		<style jsx>
			{`
				.filter-menu{
					margin: ${margin ?? "15px 0"};
    			background: #fff;
				}
				.filter-menu .head {
					padding: 20px;
				}
				.filter-menu .content {
					padding: 0 20px 20px 20px;
				}
				.filter-menu .flex {
					display: flex;
					justify-content: space-between;
				}
				.filter-menu .head .title {
					font-weight: 600;
					font-style: normal;
					font-size: 14px;
					line-height: 16px;
				}
			`}
		</style>
	</div>
);

Mobile.propTypes = {
	margin: PropTypes.string.isRequired,
	isSelected: PropTypes.any.isRequired,
	onSelected: PropTypes.func.isRequired,
};

export default Mobile;
